import type { Gallery } from '@/types/Gallery'
import type { GallerySetup } from '@/types/GallerySetup'
import { useImageFactory } from '@/model/ImageFactory'
import { useGalleryConfigSetup } from '@/composables/useGalleryConfigSetup'
import { ref } from 'vue'

const { createDefaultSetupConfig, resolveConfig, resolveGalleryExit } = useGalleryConfigSetup()
const { createFromDamImage } = useImageFactory()

const isReloadForced = ref(false)

export function useGalleryFactory() {
  const createDefault = (): Gallery => {
    return {
      texts: {
        title: '',
        description: '',
      },
      config: createDefaultSetupConfig(),
      images: [],
      closeUrl: '',
    }
  }

  const createFromConfig = (config: GallerySetup): Gallery => {
    const gallery = createDefault()

    gallery.config = resolveConfig(config.config)
    gallery.closeUrl = resolveGalleryExit(gallery.config, config.data.article?.uri)
    gallery.texts.title = config.data.gallery.texts.title
    gallery.texts.description = config.data.gallery.texts.description
    gallery.images = config.data.gallery.images.map((item) => createFromDamImage(item, gallery.config))
    if (gallery.config.navigationReloadAfter && gallery.config.navigationReloadAfter > 0) {
      window.setTimeout(() => {
        isReloadForced.value = true
      }, gallery.config.navigationReloadAfter * 1000)
    }

    return gallery
  }

  const resolveGalleryReload = (): boolean => {
    return isReloadForced.value === true
  }

  return {
    createDefault,
    createFromConfig,
    resolveGalleryReload,
  }
}
